import { GetAccountQuery } from "types/graphql-schema";

export type RoutineKey = "daily-brief" | "meeting-prep";

export const ROUTINE_KEYS: RoutineKey[] = ["daily-brief", "meeting-prep"];

export const isRoutineKey = (s: string): s is RoutineKey =>
  (ROUTINE_KEYS as string[]).includes(s);

type Me = NonNullable<GetAccountQuery["me"]>;

export type RoutineSummary = {
  key: RoutineKey;
  name: string;
  skill: string;
  enabled: boolean;
  scheduleLabel: string;
  lastRunLabel: string;
};

const formatHour = (hour: number) => {
  const period = hour < 12 ? "AM" : "PM";
  const display = hour % 12 === 0 ? 12 : hour % 12;
  return `${display}:00 ${period}`;
};

export const getRoutines = (me: Me): RoutineSummary[] => [
  {
    key: "daily-brief",
    name: "Daily Brief",
    skill: "/daily-brief",
    enabled: me.dailyBriefEnabled ?? true,
    scheduleLabel: `Daily at ${formatHour(me.dailyBriefHour ?? 9)}`,
    lastRunLabel: "—",
  },
  {
    key: "meeting-prep",
    name: "Meeting Prep",
    skill: "/meeting-prep",
    enabled: me.meetingPrepEnabled ?? true,
    scheduleLabel: `${me.meetingPrepLeadTimeMinutes ?? 10} minutes before meetings`,
    lastRunLabel: "—",
  },
];

export const findRoutine = (me: Me, key: RoutineKey): RoutineSummary => {
  const routine = getRoutines(me).find((r) => r.key === key);
  if (!routine) {
    throw new Error(`Unknown routine key: ${key}`);
  }
  return routine;
};
